import { render, staticRenderFns } from "./PlcItemPanel.vue?vue&type=template&id=2c27e24e&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./PlcItemPanel.vue?vue&type=script&lang=js"
export * from "./PlcItemPanel.vue?vue&type=script&lang=js"
import style0 from "./PlcItemPanel.vue?vue&type=style&index=0&id=2c27e24e&prod&scoped=true&lang=css"
import style1 from "./PlcItemPanel.vue?vue&type=style&index=1&id=2c27e24e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c27e24e",
  null
  
)

export default component.exports